//import { toast } from '@/components';
import {
  DAILYMOTION_URL,
  FACEBOOK_URL,
  INSTAGRAM_URL,
  LINKEDIN_URL,
  TWITTER_URL,
  YOUTUBE_URL,
} from "../constants/socialMediaUrls";

export const createScreenshot = (
  videoTag: HTMLVideoElement | null
): Promise<{ blobURL: string; base64Img: string }> => {
  return new Promise((resolve) => {
    let blobURL = "";
    let base64Img = "";

    if (!videoTag) {
      resolve({ blobURL, base64Img });
      return;
    }

    const canvas: HTMLCanvasElement = document.createElement("canvas");

    // Set canvas size to match the video frame
    canvas.width = videoTag.videoWidth;
    canvas.height = videoTag.videoHeight;

    // Get the 2D drawing context
    const ctx = canvas.getContext("2d");
    if (ctx) {
      // Draw the current video frame onto the canvas
      ctx.drawImage(videoTag, 0, 0, canvas.width, canvas.height);

      // Convert the canvas content to a data URL (base64)
      base64Img = canvas.toDataURL("image/png");

      // Convert the canvas content to a blob and create a URL for it
      canvas.toBlob((blob) => {
        if (blob) {
          blobURL = URL.createObjectURL(blob);
        }
        // Resolve the Promise with both blobURL and base64Img
        resolve({
          blobURL,
          base64Img,
        });
      }, "image/png");
    } else {
      // Resolve immediately if context is not available
      resolve({ blobURL, base64Img });
    }
  });
};

export function noop() {}

// Only the final extension is stripped: "interview.part1.mp4" → "interview.part1".
export const stripExtension = (name: string): string => {
  const dotIndex = name.lastIndexOf(".");
  return dotIndex > 0 ? name.slice(0, dotIndex) : name;
};

export async function copyTextToClipboard(
  text: string,
  element?: HTMLElement
): Promise<boolean> {
  const parentEl = element || document.body;
  let textarea: HTMLTextAreaElement | null = null;

  try {
    // Create and append textarea
    textarea = document.createElement("textarea");
    textarea.style.position = "fixed"; // Prevent scrolling to the bottom of the page
    textarea.style.opacity = "0"; // Make it invisible
    parentEl.appendChild(textarea);

    // Set textarea value and select it
    textarea.value = text;
    textarea.focus();
    textarea.select();

    // Attempt to copy the text
    const successful = document.execCommand("copy");
    //toast.success('Copied to clipboard');
    return successful;
  } catch {
    //toast.fail('Error in copyText function');
    return false;
  } finally {
    // Clean up: remove the textarea
    if (textarea && textarea.parentElement) {
      textarea.parentElement.removeChild(textarea);
    }
  }
}

export const openVideoInNewTab = (
  platform: string,
  videoId?: string,
  channelName?: string
): void => {
  if (!videoId) {
    return;
  }

  let url = "";
  if (platform === "youtube") {
    url = `${YOUTUBE_URL}${videoId}`;
  } else if (platform === "facebook") {
    url = `${FACEBOOK_URL}${videoId}`;
  } else if (platform === "linkedin") {
    url = `${LINKEDIN_URL}${videoId}`;
  } else if (platform === "twitter") {
    url = `${TWITTER_URL}${channelName}/status/${videoId}`;
  } else if (platform === "instagram") {
    url = `${INSTAGRAM_URL}${videoId}`;
  } else if (platform === "dailymotion") {
    url = `${DAILYMOTION_URL}${videoId}`;
  }

  if (url) {
    window.open(url, "_blank");
  }
};
